import SigliveServiceV2 from 'Service/sigliveServiceV2';

const getExportReportSession = async (queries) => {
  const { data } = await SigliveServiceV2({
    method: 'GET',
    url: `/reporting/download/session?${queries}`,
    responseType: 'blob',
  });

  return data;
};

export default getExportReportSession;
